import WrapperIntegration from "./WrapperIntegration";

window.itgWrapper = new WrapperIntegration()